import { TextFieldProps } from '@mui/material';

import { ObjectValues } from 'helpers/types';

export const VARIANT = {
  SUCCESS: 'success',
  DEFAULT: 'default',
} as const;

export type IVariant = ObjectValues<typeof VARIANT>;

export type IReadOnlyInputFieldProps = TextFieldProps & {
  name: string;
  look?: IVariant;
  allowNegative?: boolean
  decimalScale: number
};
